<template>
    <div class="eprescribe-side">
        <button class="modal__close" type="button" @click="emitEvent({ name: 'close' })">
            <common-icon name="close" size="small"></common-icon>
        </button>
        <div v-for="(eprescribe, index) in ePrescribeList" :key="index">
            <eprescribe-item-preview
                :insurancePlans="insurancePlans"
                :specialities="specialities"
                :facilityServices="facilityServices"
                :states="states"
                :index="index"
                :eprescribe="eprescribe"
                @remove-item="removeItem"
            ></eprescribe-item-preview>
        </div>
        <div class="eprescribe-side__footer">
            <common-button
                :label="'Add patient information'"
                type="secondary"
                size="large"
                @click="emitEvent({ name: 'go-next-step' })"
            ></common-button>
        </div>
    </div>
</template>

<script>
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import EprescribeItemPreview from 'components/ePrescribe/EprescribeItemPreview'

    export default {
        components: { EprescribeItemPreview },
        props: {
            ePrescribeList: { type: Array, required: true },
            insurancePlans: { type: Array, required: true },
            specialities: { type: Array, required: true },
            facilityServices: { type: Array, required: true },
            states: { type: Array, required: true },
        },
        data() {
            return {
                PracticeTypeEnum: PracticeTypeEnum,
            }
        },

        methods: {
            removeItem(index) {
                this.$emit('remove-item', index)
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .eprescribe-side {
        @include breakpoint(tablet) {
            width: 100%;
        }
        z-index: 11;
        position: absolute;
        width: 500px;
        height: 100%;
        max-height: 750px;
        overflow-y: scroll;
        top: 0;
        right: 0;
        background: #ffffff;
        box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.2);
        padding: 50px 20px;

        &__footer {
            text-align: center;
        }
    }

    .eprescribe--button {
        text-align: right;
    }
</style>
